import type { CollaborationDetails, AvailabilityBase, SocialRead } from '@/client'
import { CollaborationStatus, CountryCode } from '@/client'

export const isUpcoming = (collaboration: CollaborationDetails) => {
    const today = new Date();
    const result = new Date(collaboration.startTime) > today && [
        CollaborationStatus.ACCEPTED,
        CollaborationStatus.PENDING,
        CollaborationStatus.RESCHEDULED_REQUESTED
    ].includes(collaboration.status)
    return result
}

export const getDateStr = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const dateString = `${year}-${month}-${day}`;
    return dateString
}

export const readableTime = (isoTimeString: string) => {
    const date = new Date(isoTimeString);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`
}

export const sleep = (ms: number) => new Promise(r => setTimeout(r, ms));

export function parseValidationErrors(response: any, fields: string[], form: any) {
  if (response.status != 422) {
    return
  }

  const formErrors = {}

  fields.forEach(field => {
    const err = response.body.detail.find(item => item.loc.includes(field))
    if (err) {
      formErrors[field] = err.msg
    }
  })


  form.setErrors(formErrors)
}

export function compactNumber(num: number, digits: number = 2): string {
  const compactFormatter = Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: digits
  })

  return compactFormatter.format(num)
}

export function getSocialUrl(social: SocialRead) {
  switch (social.platform) {
    case 'instagram':
      return `https://instagram.com/${social.username}`
    case 'tiktok':
      return `https://tiktok.com/@${social.username}`
    case 'youtube':
      return `https://youtube.com/${social.username}`
  }
}

export function windowLoaded() {
  return new Promise((resolve) => {
    if (document.readyState === 'complete') {
      resolve(true)
      return
    }

    window.addEventListener('load', () => {
      resolve(true)
    })
  })
}

const currencies = {
  "gbp": "£",
  "usd": "$"
}

export function getCurrencySymbol(code: string): string {
  if (currencies[code]) {
    return currencies[code]
  }

  return code.toUpperCase()
}

const countryCurrencies = {
  [CountryCode.GB]: "£",
  [CountryCode.US]: "$",
}

export function getCountryCurrencySymbol(code: CountryCode): string {
  if (countryCurrencies[code]) {
    return countryCurrencies[code]
  }

  return "£"
}